import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

class Language extends Component {
  constructor(props) {
    super(props);
    const { t, i18n } = this.props;
    this.t = t;
    this.i18n = i18n;
  }

  changeLanguage = (e) => {
    this.i18n
      .changeLanguage(e.target.value)
      .then(localStorage.setItem('language', e.target.value));
  };

  render() {
    const language = localStorage.getItem('language') || 'en_US';
    return (
      <React.Fragment>
        <i className="md-icon">language</i>
        <span>
          <select
            onChange={this.changeLanguage}
            id="languageSelection"
            value={language}
          >
            <option value="en_US">English</option>
            {window.configs.mode === 'dev' ? (
              <option value="enX">EnglishX</option>
            ) : null}
            <option value="es_ES">Spanish</option>
            <option value="de_DE">Deutsch</option>
          </select>
        </span>
      </React.Fragment>
    );
  }
}

export default withTranslation('app')(Language);
